import React, { useState } from "react";
import { blockUser, reportUser } from "../api/safetyApi";
import "./SafetyActions.css";

const REPORT_REASONS = [
  "Nękanie lub obraźliwe zachowanie",
  "Fałszywy profil lub oszustwo",
  "Nieodpowiednie treści",
  "Spam lub reklama",
  "Inny powód"
];

function SafetyActions({ userId, onBlocked, onReported, compact = false }) {
  const [open, setOpen] = useState(false);
  const [reporting, setReporting] = useState(false);
  const [blocking, setBlocking] = useState(false);
  const [reported, setReported] = useState(false);
  const [blocked, setBlocked] = useState(false);
  const [error, setError] = useState("");
  const [reason, setReason] = useState(REPORT_REASONS[0]);
  const [details, setDetails] = useState("");
  const [confirmBlock, setConfirmBlock] = useState(false);

  if (!userId) {
    return null;
  }

  async function handleReport(event) {
    event.preventDefault();
    try {
      setReporting(true);
      setError("");
      await reportUser({ reportedUserId: userId, reason, details: details.trim() });
      setReported(true);
      setOpen(false);
      if (onReported) {
        onReported();
      }
    } catch (requestError) {
      console.error("Report user error:", requestError);
      setError("Nie udało się wysłać zgłoszenia. Spróbuj ponownie.");
    } finally {
      setReporting(false);
    }
  }

  async function handleBlock() {
    try {
      setBlocking(true);
      setError("");
      await blockUser(userId);
      setBlocked(true);
      setConfirmBlock(false);
      setOpen(false);
      if (onBlocked) {
        onBlocked();
      }
    } catch (requestError) {
      console.error("Block user error:", requestError);
      setError("Nie udało się zablokować użytkownika. Spróbuj ponownie.");
    } finally {
      setBlocking(false);
    }
  }

  return (
    <div className="safety-actions">
      {reported && <span className="safety-state">Zgłoszono</span>}
      {blocked && <span className="safety-state">Zablokowano</span>}
      {!reported && !blocked && (
        <button
          type="button"
          className={compact ? "safety-menu-button compact" : "safety-menu-button"}
          aria-label="Opcje bezpieczeństwa"
          aria-expanded={open}
          onClick={() => {
            setOpen((current) => !current);
            setError("");
          }}
        >
          ⋮
        </button>
      )}

      {open === true && (
        <div className="safety-menu" role="menu">
          <button
            type="button"
            role="menuitem"
            onClick={() => {
              setConfirmBlock(false);
              setOpen("report");
            }}
          >
            Zgłoś użytkownika
          </button>
          <button type="button" role="menuitem" onClick={() => setConfirmBlock(true)}>
            Zablokuj użytkownika
          </button>
        </div>
      )}

      {open === "report" && (
        <div className="safety-modal-backdrop" role="presentation" onClick={() => setOpen(false)}>
          <form className="safety-modal" onSubmit={handleReport} onClick={(event) => event.stopPropagation()}>
            <h2>Zgłoś użytkownika</h2>
            <label>
              Powód
              <select value={reason} onChange={(event) => setReason(event.target.value)}>
                {REPORT_REASONS.map((item) => <option key={item}>{item}</option>)}
              </select>
            </label>
            <label>
              Dodatkowe informacje (opcjonalnie)
              <textarea value={details} onChange={(event) => setDetails(event.target.value)} maxLength={1000} rows={4} />
            </label>
            {error && <p className="safety-error">{error}</p>}
            <div className="safety-modal-actions">
              <button type="button" onClick={() => setOpen(false)}>Anuluj</button>
              <button type="submit" disabled={reporting}>{reporting ? "Wysyłanie..." : "Wyślij zgłoszenie"}</button>
            </div>
          </form>
        </div>
      )}

      {confirmBlock && (
        <div className="safety-modal-backdrop" role="presentation" onClick={() => setConfirmBlock(false)}>
          <div className="safety-modal" onClick={(event) => event.stopPropagation()}>
            <h2>Zablokować użytkownika?</h2>
            <p>Nie będzie mógł wysyłać Ci wiadomości ani pojawiać się w Twoich dopasowaniach.</p>
            {error && <p className="safety-error">{error}</p>}
            <div className="safety-modal-actions">
              <button type="button" onClick={() => setConfirmBlock(false)}>Anuluj</button>
              <button type="button" className="safety-danger" disabled={blocking} onClick={handleBlock}>
                {blocking ? "Blokowanie..." : "Zablokuj"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SafetyActions;
